import { useState, useEffect } from "react";
import Main from "./components/Main";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import AskDelete from "./components/AskDelete";
import Support from "./components/Support";
import AdminDashboard from "./components/AdminDashboard";

// URL discrète du tableau de bord (protégé par mot de passe côté serveur).
const ADMIN_PATH = "/zlejfnezzefez";
import { detectLang } from "./i18n";

function resolvePage(path) {
  if (path === ADMIN_PATH || path === `${ADMIN_PATH}/`) return "admin";
  // Variantes anglaises : /en/terms, /en/privacy… → même page, langue EN
  // (la langue est détectée séparément par detectLang).
  const p = path.startsWith("/en/") ? path.slice(3) : path;
  if (p === "/terms") return "terms";
  if (p === "/privacy") return "privacy";
  if (p === "/askdelete") return "askdelete";
  if (p === "/support") return "support";
  // /en, /en/, et toute autre route inconnue → home (langue détectée à part)
  return "home";
}

function App() {
  const [currentPage, setCurrentPage] = useState(() =>
    resolvePage(window.location.pathname)
  );
  const [lang, setLang] = useState(() => detectLang());

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPage(resolvePage(window.location.pathname));
      setLang(detectLang(window.location.pathname));
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigateTo = (page, path) => {
    setCurrentPage(page);
    window.history.pushState(null, "", path);
    setLang(detectLang(path));
    // Nouvelle page = repartir du haut. Les liens légaux vivent dans le
    // footer : sans ça on atterrissait tout en bas de Terms/Privacy.
    window.scrollTo(0, 0);
  };

  const toggleLang = () => {
    const nextLang = lang === "fr" ? "en" : "fr";
    const nextPath = nextLang === "en" ? "/en" : "/";
    setLang(nextLang);
    setCurrentPage("home");
    window.history.pushState(null, "", nextPath);
    window.scrollTo(0, 0);
  };

  const renderPage = () => {
    switch (currentPage) {
      case "terms":
        return <TermsOfService lang={lang} />;
      case "privacy":
        return <PrivacyPolicy lang={lang} />;
      case "askdelete":
        return <AskDelete />;
      case "support":
        return <Support />;
      case "admin":
        return <AdminDashboard />;
      default:
        return (
          <Main navigateTo={navigateTo} lang={lang} onToggleLang={toggleLang} />
        );
    }
  };

  return <div className="min-h-screen">{renderPage()}</div>;
}

export default App;
